import { makeRequest } from 'utils/REST';
const BASE_API_PATH = window.config.baseAPIPath;

class StreamingService {
    request(requestType, url) {
        return makeRequest(requestType, url)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            });
    }

    get(streamId) {
        return this.request(
            'get',
            `${BASE_API_PATH}/sport/stream/${streamId}?type=hls`
        );
    }
    GetOnlineStream(streamId, streamType) {
        return this.get(streamId, streamType);
    }
}

export default new StreamingService();
